import React from 'react';
import { Grid, Button, Typography, Container, Paper, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { listingCss } from 'common/style/style';

const classes = listingCss();

const Header = (props) => {
    const { title, description, buttonName, link } = props.value;
    const navi = useNavigate();

    const onButtonPress = () => {
        navi(link);
    }

    return (
        <Container maxWidth={false} sx={{ backgroundColor: "#e0dcdcff!important", margin: "10px 0" }} >
            <Grid container justifyContent={'space-between'} alignItems={'center'}>
                <Typography variant="h6" sx={{ fontWeight: "bold", margin: "15px 0" }}>{title || ''}</Typography>
                {/* <Button variant='contained' >Create Subscription</Button> */}
            </Grid>
        </Container>
    )
}

export default Header;
